export default "__VITE_ASSET__d832b90a__"